<template>
  <div class="select__wrapper">
    <select
      :id="select"
      :name="select"
      class="select text-truncate"
      :style="{ width: customWidth }"
      @change="onChange($event.target.value)"
    >
      <option
        v-if="selectLabel"
        :key="selectLabel"
        value=""
        :selected="!selectedValue"
        disabled
        hidden
      >
        {{ selectLabel }}
      </option>
      <option
        v-for="option in options"
        :key="option.id"
        :value="option.id"
        :selected="option.id === selectedValue"
        :data-testid="`option-${option.id}`"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    selectLabel: {
      type: String,
      default: '',
    },
    select: {
      type: String,
      default: 'select',
    },
    options: {
      type: Array,
      required: true,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    selectedValue: {
      type: String,
      default: '',
    },
    customWidth: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.select__wrapper {
  align-items: center;
  display: flex;
}

select,
label {
  color: $black;
}

select {
  background: #fff
    url("data:image/svg+xml;charset=UTF-8,%3csvg width='13' height='7' viewBox='0 0 13 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M-0.00012207 1.59933L-0.000122024 0.532662C0.00023454 0.431807 0.0291242 0.333113 0.0832072 0.247984C0.13729 0.162856 0.214358 0.0947691 0.305505 0.0515943C0.396652 0.00841942 0.498156 -0.00808149 0.598286 0.00399909C0.698415 0.0160797 0.793082 0.0562481 0.871345 0.119862L6.39988 4.6436L11.9289 0.119864C12.0072 0.0561901 12.1018 0.0159707 12.2019 0.00386226C12.302 -0.00824615 12.4035 0.00825137 12.4947 0.0514453C12.5858 0.0946393 12.6628 0.162763 12.7168 0.247928C12.7709 0.333092 12.7997 0.431814 12.7999 0.532664V1.59933C12.7999 1.67834 12.7823 1.75636 12.7484 1.82775C12.7146 1.89914 12.6653 1.96212 12.6041 2.01213L6.73748 6.81213C6.64208 6.88997 6.52274 6.93249 6.39961 6.93249C6.27649 6.93249 6.15714 6.88997 6.06174 6.81213L0.195078 2.01213C0.0718779 1.9108 -0.000122091 1.75933 -0.00012207 1.59933Z' fill='%23000'/%3e%3c/svg%3e")
    no-repeat right 0.75rem top 52%;
  background-clip: padding-box;
  border: 1px solid $grey-02;
  border-radius: 4px;
  padding: 0.6rem 2rem 0.6rem 0.75rem;
  -webkit-appearance: none;
  appearance: none;
  outline: none;
}

label {
  margin-bottom: 0;
  white-space: nowrap;
}
</style>
